function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(568.855 171.701) rotate(66)",
  opacity: 0.37
}, /*#__PURE__*/React.createElement("path", {
  d: "M-291.905,365.968c13.677,3.288,88.97,54.495,86.2,94.761-2.753,40.028-47.467,37.433-63.812,38.828s-41.123,13.457-57.3-4.735-5.827-29.762-7.586-49.7S-345.3,353.131-291.905,365.968Z",
  transform: "translate(0 -31.714)",
  fill: "#e9eaea"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-333.531 321.176)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-322.013,392.017a2.254,2.254,0,0,1-1.954,2.519,2.254,2.254,0,0,1-2.518-1.954,2.254,2.254,0,0,1,1.954-2.519A2.254,2.254,0,0,1-322.013,392.017Z",
  transform: "translate(326.503 -371.652)",
  fill: "#e9eaea"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-287.23,327.949l-.221.092a3.36,3.36,0,0,1-2.791.034,2.337,2.337,0,0,0-2.457.226,2.31,2.31,0,0,0-.9,2.15,2.336,2.336,0,0,0,3.213,1.861,2.323,2.323,0,0,0,1.3-1.381,3.232,3.232,0,0,1,1.809-1.918l.463-.193a2.733,2.733,0,0,1,2.845.545,4.666,4.666,0,0,0,5.436.488,4.69,4.69,0,0,0,2.107-5.284,4.665,4.665,0,0,0-6.28-3.033,4.664,4.664,0,0,0-2.868,4.127A2.633,2.633,0,0,1-287.23,327.949Z",
  transform: "translate(302.405 -321.176)",
  fill: "#e9eaea"
})));

var SvgHeroRb = function SvgHeroRb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181.252,
    height: 176.257,
    viewBox: "0 0 181.252 176.257",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeroRb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero-rb.76e610cf.svg";
export { ForwardRef as ReactComponent };